import { Component, OnInit , Input} from '@angular/core';
import { DataService } from "../../services/data.service";
import { APIService } from '../../api.service';
import { CommonService } from '../../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-basic-prd-print',
  templateUrl: './basic-prd-print.component.html',
  styleUrls: ['./basic-prd-print.component.scss']
})

export class BasicPrdPrintComponent implements OnInit {
  agencyData: any = [];
  jarvisData: any = [];
  AgcData: any = []; 
  tranjectionData: any = [];
  items: any = [];
  configData: any = [];
  userData: any = [];
  storeName: any = '';
  unitList: Array<any> = [];
  AgencyName: string = '';
  City : string = '';
  State: string = '';
  printHeaderImg: any = '';
  cusHeader : any = [];
  total: number = 0;
  xnNo: number = 0;
  xnDate: any = new Date();
  CompanyName : string = '';
  Name : string = '';
  printHeader: string = "";
  addShow : boolean = false;
  suppShow : boolean = false;
  bomData : any = [];
  selStoreItems  : any = [];
  getAllItems : any = [];
  customHeader : any = {
    cmpLogo: '',
    cmpName: '',
    gstin: '',
    cin: '',
    address: '',
    mobile: '',
    showLogo: false,
    side: 1
  }
  ForERPAgencyID = 0;
  frmStoreID = 0;
  inStoreID = 0;
  outStoreID = 0;

  constructor(private commonFunService: CommonService, private apiService: APIService,private dataSer: DataService,private loadingPnl: NgxSpinnerService) {}

  ngOnInit(): void {
    var agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      if(this.agencyData){
      this.printHeaderImg = this.agencyData[0].Letterhead;
      this.cusHeader = this.agencyData[0].PHJSON;
      this.ForERPAgencyID = this.agencyData[0].ERPAgencyID;
        if(this.cusHeader != '[]'){
          this.cusHeader = JSON.parse(this.cusHeader);
          this.customHeader.cmpName = this.cusHeader[0].cnm;
          this.customHeader.gstin = this.cusHeader[0].gstin ? this.cusHeader[0].gstin : this.agencyData[0].GSTIN;
          this.customHeader.cin = this.cusHeader[0].cin;
          this.customHeader.address = this.cusHeader[0].add;
          this.customHeader.mobile = this.cusHeader[0].cno;
          this.customHeader.showLogo = this.cusHeader[0].inlHdr;
          this.customHeader.side = this.cusHeader[0].side;
          this.customHeader.cmpLogo = this.agencyData[0].Logo;
        }
    }
  }

  this.apiService.getIDB('erp_inv', (erp_inv: any) => {
    if (erp_inv && erp_inv.length > 0) {
      this.getAllItems = erp_inv;
    }
  });

    this.getPrdData();
    
  }


  printBasicPrdData() {
    setTimeout(function () {
        var printArea = $('#basiPrdPrint').html();
        $('body').html(printArea);
        window.print();
    });
  }

  getPrdData(){
    debugger
    let XnID =  this.commonFunService.encryptData(this.commonFunService.GetParam('XnID'));
    let agencyID: any = this.commonFunService.encryptData(this.commonFunService.GetParam('aid'));
    var tempData = [{
      'XnID': XnID,
      'AgencyID': agencyID
  }]
    let myParams = [{
        myUserID: 0,
        myToken: '',
        forAgencyID: agencyID,
        myAgencyIDs: agencyID, 
        ForERPAgencyID: 0,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getXnDetailsExt',
        moduleID: 11,
        data: JSON.stringify(tempData)
    }];
    this.apiService.getData(myParams, this.successPRDRespItem.bind(this), this.failureResp.bind(this));
    }

      //successResp - success  get handler
   successPRDRespItem(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
      console.log(res.message);
    }
    else {
      debugger
      if (res) {
        debugger;
          var reponseData = JSON.parse(res.updatePackage);
          if(reponseData.Table[0].ErrCode != -1){
            this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          }
          else{
            //Own Agency Data
            this.agencyData = reponseData.Table1;
            this.AgencyName = this.agencyData[0].AgencyName;
            if(this.agencyData[0].Letterhead){
              if(this.apiService.fn_isLiveURL() == true){
                this.printHeader = "https://biziverse.com/" + this.agencyData[0].Letterhead;
              }
              else{
                this.printHeader = "http://localhost:60228/" + this.agencyData[0].Letterhead;
              }
            }
            
            //Own Agency's Config Data
            this.configData = reponseData.Table2;
            if(this.configData[0].Stores)
            {
              var Stores = JSON.parse(this.configData[0].Stores)

            }
            if(reponseData.Table4){
              let itemData = reponseData.Table4;
              var id: number = 0;
              if(itemData.length > 0){
                this.inStoreID = itemData[0].InStoreID;
                this.outStoreID = itemData[0].OutStoreID;
                this.xnNo  = itemData[0].XnNo;
                this.xnDate = itemData[0].XnDate; 
              }
              if(this.inStoreID > 0){
                id= this.inStoreID;
              }
              else{
                id = this.outStoreID;
              }
              var StoreData = Stores.filter(function (element: any, index: any) {
                return (element.StrID == id);
              });
  
              if(StoreData.length > 0){
                this.storeName = StoreData[0].sNm;
              }
              else{
                this.storeName = "-";
              }
            }

          
            this.unitList = JSON.parse(this.configData[0].Units);
        
            // Own Agency's Users
            this.userData = reponseData.Table3;
            var batches = [];
            if(reponseData.Table4){
              var itemData = reponseData.Table4;
              itemData.forEach((a: any) => {	
                var btchStr: any = "";
                if((a.BatchType == 1 || a.BatchType == 2) && a.XnBInfo){
                  batches = JSON.parse(a.XnBInfo);
                  for(let i = 0; i < batches.length; i++){
                    let batchName = batches[i].B;
                    let batchQty = batches[i].Q;
                    let coma = ', ';

                    if(i != (batches.length - 1)){
                      btchStr = btchStr + batchName + " (" + batchQty + ")" + coma
                    }
                    else{
                      btchStr = btchStr + batchName + " (" + batchQty + ")" 
                    }
                  }
                  a.btchStr = btchStr;
                }
              });

              for(let i = 0; i < itemData.length; i++){
                let selectedUnit: Array<any> = $.grep(this.unitList, function(o: any){ return o.UNm == itemData[i].Unit});

                let precision: number = 0;
                if(selectedUnit.length > 0){
                  precision = selectedUnit[0].Prcsn;
                }
                if(itemData[i].IQty != 0){
                  let selItems = this.getAllItems.filter((x: any) => x.ItemID == itemData[i].ItemID);
                  let temp = {
                    IID: itemData[i].ItemID,
                    ItemName: itemData[i].ItemName,
                    IQ: this.commonFunService.PrecisionwiseValue(itemData[i].IQty + "", precision, true),
                    ISID: itemData[i].IStrID,
                    SrNo: itemData[i].SrNo,
                    Unit: itemData[i].Unit,    
                    Total: itemData[i].OQty * itemData[i].Rate,
                    StkQty : selItems[0].CurrQty,
                    BatchType:  itemData[i].BatchType,
                    btchStr:  itemData[i].btchStr
                    // StoreQty : selstrItems[0].StoreItemQty ? selstrItems[0].StoreItemQty : "0"
                  }
                  this.items.push(temp);
                }
                
                if(itemData[i].OQty != 0){
                  let selItems = this.getAllItems.filter((x: any) => x.ItemID == itemData[i].ItemID);
                  let tempBOM = {
                    IID: itemData[i].ItemID,
                    ItemName: itemData[i].ItemName,
                    OQ: this.commonFunService.PrecisionwiseValue(itemData[i].OQty + "", precision, true),
                    OSID: itemData[i].OStrID,
                    SrNo: itemData[i].SrNo,
                    TID: itemData[i].TID,
                    Unit: itemData[i].Unit,  
                    StkQty : selItems[0].CurrQty,
                    BatchType:  itemData[i].BatchType,
                    btchStr:  itemData[i].btchStr
                    // StoreQty : selstrItems[0].StoreItemQty ? selstrItems[0].StoreItemQty : "0"
                  }
                  this.bomData.push(tempBOM);
                }
              }
            } 
        }
      }
      this.printBasicPrdData(); 
    }
  }

 
  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }
}

